<ng-template cdk-portal  #loadingView>
    <div class="ListOverlay">
      <div class="spinner-wrapper">
        <div style="text-align: center;" *ngIf="isShowSpinner">
          <mat-spinner diameter="36"></mat-spinner>
        </div>
        <ng-container >  {{message}}  </ng-container>
      </div>
      <ng-container *ngIf="showProgress">
        <div style="text-align: center;" *ngIf="progressMode=='determinate' && !isProgressInPercentage"> {{progressNumber}} / {{progressTotal}} </div>
        <div style="text-align: center;" *ngIf="progressMode=='determinate' && isProgressInPercentage"> {{(progressPercent/100) | percent: '1.0-0'}} </div>
        <mat-progress-bar [mode]="progressMode" [value]="progressPercent"></mat-progress-bar>
      </ng-container>
    </div>
  </ng-template>
